// removed by extract-text-webpack-plugin
module.exports = {"PreLoader":"theme__PreLoader___3XrDY","sizeSmall":"theme__sizeSmall___naamT","sizeMedium":"theme__sizeMedium___QMhBs","sizeLarge":"theme__sizeLarge___3qsHp","PreLoader_svg":"theme__PreLoader_svg___2WXDP","preloader-rotate":"theme__preloader-rotate___gaRkN","PreLoader_svg_path":"theme__PreLoader_svg_path___VJIW1","preloader-path-rotate":"theme__preloader-path-rotate___znzF3","inverted":"theme__inverted___31-LV"};


//////////////////
// WEBPACK FOOTER
// ./~/@wevo/react-components/lib/PreLoader/theme.css
// module id = 1533
// module chunks = 0